
    import './styles.scoped.css';
    export default {
  "resize-active": "awsui_resize-active_lm6vo_sxwc2_104",
  "resize-side": "awsui_resize-side_lm6vo_sxwc2_110",
  "resize-bottom": "awsui_resize-bottom_lm6vo_sxwc2_113",
  "with-motion": "awsui_with-motion_lm6vo_sxwc2_118",
  "root": "awsui_root_lm6vo_sxwc2_133",
  "root-no-scroll": "awsui_root-no-scroll_lm6vo_sxwc2_140",
  "layout": "awsui_layout_lm6vo_sxwc2_145",
  "layout-no-scroll": "awsui_layout-no-scroll_lm6vo_sxwc2_151",
  "layout-main": "awsui_layout-main_lm6vo_sxwc2_155",
  "layout-main-scrollable": "awsui_layout-main-scrollable_lm6vo_sxwc2_161",
  "unfocusable": "awsui_unfocusable_lm6vo_sxwc2_166",
  "breadcrumbs-desktop": "awsui_breadcrumbs-desktop_lm6vo_sxwc2_170",
  "content-header-wrapper": "awsui_content-header-wrapper_lm6vo_sxwc2_175",
  "content-wrapper": "awsui_content-wrapper_lm6vo_sxwc2_179",
  "content-overlapped": "awsui_content-overlapped_lm6vo_sxwc2_183",
  "content-extra-top-padding": "awsui_content-extra-top-padding_lm6vo_sxwc2_187"
};
  